<template>
    <div>
        <div v-if="!isCurrentShopAllowed">
            <p class="text-center">{{ $t("checkout.banContactNotAvailable") }} {{ shopName }}</p>
        </div>

        <div v-else v-show="hasIFrame === null">
            <div class="checkout__card">
                <div class="account__border hidden-md-down">
                    <div class="account__card--topbar py-2 account__card--topbar--padding d-flex justify-content-between align-items-center">
                        <div class="text--green font-weight-bold">Bancontact</div>
                        <div style="width: 60px">
                            <checkout-payment-credit-card-logo credit-card-issuer="BANCONTACT"></checkout-payment-credit-card-logo>
                        </div>
                    </div>
                </div>
                <div v-if="isFetchingCreditCards">
                    <div class="row">
                        <div class="col my-4 text-center">
                            <img class="mx-auto"
                                 style="height: 25px;"
                                 src="/themes/brekz-2017/img/loading-indicator-l.gif">
                            <b class="ml-1 my-auto">{{ $t("checkout.loading") }}</b>
                        </div>
                    </div>
                </div>
                <div v-if="isMobile"
                     class="checkout__creditcard--wrapper-title text-center py-2">{{ $t("checkout.lastStep") }}
                </div>
                <div class="account__card--inner">
                    <div v-if="!isMobile && userCards.length > 0"
                         class="account__border pb-4">
                        <div class="pt-3 pb-2 checkout--grey-text">{{ $t("checkout.savedCard", {card: 'Bancontact card'}) }} </div>
                        <div class="row mb-1"
                             v-for="userCard in userCards">
                            <div class="col-6">
                                <div @click="handleSelectedCard(userCard.key, userCard.paymentMethod)"
                                     class="d-flex align-items-center checkout__mini-card">
                                    <input class="mr-2"
                                           :checked="userCard.key === selectedCard"
                                           type="radio"
                                           value="">
                                    <div class="checkout__mini-card--text mr-2">{{ $t("checkout.cardNumber") }} </div>
                                    <div class="mr-2 checkout__mini-card--text">{{ styleDescription(userCard.description) }}</div>
                                    <div class="ml-auto py-2 px-2"
                                         style="width: 70px">
                                        <checkout-payment-credit-card-logo :credit-card-issuer="userCard.paymentMethod"></checkout-payment-credit-card-logo>
                                    </div>
                                    <i @click="deleteCard(userCard.key)"
                                       class="checkout__mini-card--delete fas fa-trash"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="isMobile && !isFetchingCreditCards">
                    <div v-if="intentUrl"
                         @click="useBancontactAppClickHandler"
                         class="account__card--inner checkout__selector d-flex align-items-center">
                        <div class="d-flex align-items-center">
                            <input class="mr-2"
                                   :checked="useBancontactApp"
                                   type="radio"
                                   value="">
                            <div>{{ $t("checkout.payWith") }} <b>{{ $t("checkout.bancontactApp") }}</b></div>

                        </div>
                    </div>
                    <div v-if="intentUrl"
                         class="checkout--spacer"></div>
                    <div v-if="userCards.length > 0">
                        <swipe-list
                            ref="list"
                            class="card"
                            :items="userCards"
                            item-key="id"
                        >
                            <template v-slot="{ item, index, revealLeft, revealRight, close }">

                                <div class="account__card--inner d-flex align-items-center checkout__selector">
                                    <div @click="(selectedCard = item.key) && (handleSelectedCard(item.key, item.paymentMethod))"
                                         class="d-flex align-items-center w-100 checkout--grey-text">
                                        <input class="mr-2 cursor-pointer"
                                               :checked="item.key === selectedCard"
                                               type="radio"
                                               value="">
                                        <div class="checkout__mini-card--text mr-2">{{ $t("checkout.cardNumber") }} </div>
                                        <div class="mr-2 checkout__mini-card--text">{{ styleDescription(item.description) }}</div>
                                        <div class="ml-auto px-2"
                                             style="width: 70px">
                                            <checkout-payment-credit-card-logo :credit-card-issuer="item.paymentMethod"></checkout-payment-credit-card-logo>
                                        </div>
                                    </div>
                                </div>
                                <div class="checkout--spacer"></div>

                            </template>

                            <template v-slot:right="{ item }">
                                <div @click="deleteCard(item)"
                                     class="swipeout-action bg-danger px-5 d-flex">
                                    <i class="fa fa-trash my-auto text--white"></i>
                                    <div class="checkout--spacer"></div>
                                </div>
                            </template>
                        </swipe-list>
                    </div>


                    <div v-if="!useNewCard"
                         @click="createNewCard"
                         class="account__card--inner checkout__selector d-flex align-items-center">
                        <div class="d-flex align-items-center">
                            <input class="mr-2"
                                   type="radio"
                                   value="">
                            <div>{{ $t("checkout.useOtherBancontact") }}</div>
                        </div>
                    </div>
                    <div class="checkout--spacer"></div>
                </div>

                <div v-show="!isFetchingCreditCards"
                     class="account__card--inner">
                    <div v-if="userCards.length > 0">
                        <div v-if="!isMobile && !useNewCard"
                             class="pt-3 pb-2 checkout--grey-text">{{ $t("checkout.useNewBancontact") }}
                        </div>
                        <div v-if="!useNewCard && !isMobile"
                             class="row">
                            <div class="col-12 col-md-6">
                                <div @click="createNewCard()"
                                     class="d-flex align-items-center checkout__mini-card text--green py-2 mb-2">
                                    <i class="fas fa-plus mr-2"></i>
                                    <div>{{ $t("checkout.addNewBancontact") }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row pb-3 hidden">
                        <div v-if="!isMobile"
                             class="col-12 col-lg-6 checkout--border-right pt-3">
                            <div v-show="useNewCard">
                                <p v-if="!savePaymentDetails && isMobile"
                                   class="checkout__creditcard--wrapper-title text-center">{{ $t("checkout.lastStep") }}</p>
                                <div class="text--green font-weight-bold mb-3">{{ $t("checkout.payWithBancontactApp") }}</div>
                                <div class="d-flex justify-content-center">
                                    <img :src="qrCode"
                                         class="mb-5"
                                         style="width: 250px"
                                         alt="bancontact QR code"
                                         v-show="qrCodeIsLoaded"
                                         @load="qrCodeIsLoaded = true">
                                    <img v-show="!qrCodeIsLoaded"
                                         src="/themes/brekz-2017/img/loading-indicator-l.gif"
                                         class="mb-5 mt-4"
                                         alt="Loading bancontact QR code">
                                </div>
                                <p>
                                    <i>{{ $t("checkout.openBancontactApp") }}</i>
                                </p>
                                <p><i>{{ $t("checkout.noBancontactApp") }}</i></p>
                            </div>

                        </div>
                        <div v-show="useNewCard"
                             class="col-12 col-lg-6 pt-3">
                            <div class="row mb-3">
                                <div class="col">
                                    <div class="row">
                                        <div class="col-12">
                                            <div class="mb-1">{{ $t("checkout.cardNumber") }}</div>
                                            <input type="text"
                                                   class="input"
                                                   placeholder="XXXX XXXX XXXX XXXXX"
                                                   maxlength="20"
                                                   @focus="isValidCard = true"
                                                   @blur="validateBancontactNumber"
                                                   @keyup="updateBanContactCode"
                                                   @keyup.left="buttonPressLeft"
                                                   @keyup.right="buttonPressRight"
                                                   id="cardNumber"
                                                   ref="cardNumber"
                                                   :class="{ 'input--error': !isValidCard }">
                                            <small v-if="!isValidCard"
                                                   class="text-danger">{{ $t("checkout.errorCard") }}</small>
                                        </div>
                                    </div>


                                    <div class="row mb-3">
                                        <div class="col-12">
                                            <div class="mb-1">{{ $t("checkout.name") }}</div>
                                            <input type="text"
                                                   :class="{ 'input--error': !isValidCardHolderName }"
                                                   class="input"
                                                   placeholder="Jan Janssen"
                                                   maxlength="22"
                                                   v-model="cardHolderName"
                                                   @focus="isValidCardHolderName = true"
                                                   @blur="validateCardHolderName"
                                                   @keyup.left="buttonPressLeft"
                                                   @keyup.right="buttonPressRight"
                                                   id="cardNameHolder"
                                                   ref="cardNameHolder">
                                            <small v-if="!isValidCardHolderName"
                                                   class="text-danger">{{ $t("checkout.errorName") }}</small>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-12">
                                            <div class="mb-1">{{ $t("checkout.expireDate") }}</div>
                                            <div class="row">
                                                <div class="col-6">
                                                    <input type="text"
                                                           class="input"
                                                           placeholder="12/24"
                                                           :class="{ 'input--error': !isValidExpirationDate }"
                                                           maxlength="5"
                                                           @focus="isValidExpirationDate = true"
                                                           @blur="validateExpirationDate"
                                                           @keyup="updateBanContactExpirationDate"
                                                           @keyup.left="buttonPressLeft"
                                                           @keyup.right="buttonPressRight"
                                                           id="cardExpireDate"
                                                           ref="cardExpireDate">
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-12">
                                                    <small v-if="!isValidExpirationDate"
                                                           class="text-danger">{{ $t("checkout.errorDate") }}</small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div class="account__border w-100 my-4">

                            </div>

                        </div>
                    </div>

                    <div class="col-md-6 col-12">
                        <div class="d-flex mb-1 align-items-center mb-3">
                            <div class="mr-1 font-weight-bold">{{ $t("checkout.total") }}</div>
                            <div class="text--sm text--gray-100">{{ $t("checkout.taxIncl") }}</div>
                            <div v-for="cart in cartArray"
                                 class="ml-auto text--lg text--green"><strong>{{cart.total}}</strong></div>
                        </div>
                    </div>
                    <div class="col-12" v-show="! useBancontactApp">
                        <div class="d-flex">
                            <label class="toggle-switch mr-2 mt-1">
                                <input class="toggle-switch--input"
                                       name="save_payment_details"
                                       v-model="savePaymentDetails"
                                       :disabled="useBancontactApp"
                                       type="checkbox">
                                <span class="toggle-switch--slider round"></span>
                            </label>
                            <div style="font-size: 0.9rem">
                                {{ $t('checkout.mistercacheSave')}}
                                <span class="text--gray-100">{{ $t("checkout.nextTime") }}</span></div>

                            <input type="hidden" name="creditcard_type" v-model="creditCardIssuer">
                            <input type="hidden" name="ciphertext" value="">
                        </div>
                    </div>

                </div>
            </div>
            <div class="py-4 account__card--bottom-bar align-items-center"
                 :class="[!isMobile ? 'checkout--border-top mt-3' : '']">
                <img v-if="isSubmitting"
                     alt="Submitting..."
                     class="mr-auto"
                     style="height: 25px;"
                     src="/themes/brekz-2017/img/loading-indicator-l.gif">
                <button class="button button--clear checkout__cancel-button m-0 hidden-sm-down"
                        @click="cancelPayment()"
                        :disabled="isSubmitting">{{ $t("checkout.cancel") }}
                </button>
                <a v-if="useBancontactApp && intentUrl"
                   :href="intentUrl"
                   :title='$t("checkout.order")'
                   class="button-brekz button-brekz--rounded button-brekz--yellow button-brekz--xl w-100-sm m-0 d-flex">
                    <span class="ml-auto mr-md-auto">{{ $t("checkout.order") }}</span>
                    <i class="fas fa-chevron-right my-auto ml-auto d-md-none"></i>
                </a>
                <button v-else type="submit"
                        :disabled="isSubmitting || !allInputValid || isFetchingCreditCards"
                        @click="savePaymentDetails ? saveCreditCard() : startPayment()"
                        name="submitPaymentMethod"
                        class="button-brekz button-brekz--rounded button-brekz--yellow button-brekz--xl w-100-sm m-0 d-flex">
                    <span class="ml-auto mr-md-auto">{{ $t("checkout.order") }}</span>
                    <i class="fas fa-chevron-right my-auto ml-auto d-md-none"></i>
                </button>
            </div>
            <button class="button button--clear m-0 hidden-md-up mt-2 mb-4 mx-3"
                    @click="cancelPayment()">
                <div class="d-flex align-items-center">
                    <i class="fas fa-chevron-left mr-3 text--green"></i>{{ $t("checkout.back") }}
                </div>
            </button>
        </div>

        <div id="iframe-area" class="checkout__iframe" v-show="hasIFrame">
        </div>

        <div v-show="OrderId !== '' && hasIFrame" class="px-5 py-3 text--green text-center">
            Not loading after 20 seconds? Please contact Brekz customer service <i>(your order ID is: {{ OrderId }})</i> or check your order status IN A NEW TAB.
        </div>

        <div v-show="hasIFrame === false" class="py-4" id="proceedWaiting">
            <h2 class="text--green text-center">{{ $t("checkout.processWaiting.title")}}</h2>
            <p class="text-center mt-4">{{ $t("checkout.processWaiting.description")}}</p>

            <div class="proceedWaiting__loading-box">
                <div class="loading-dots">
                    <div class="loading-dots__wrapper">
                        <div class="loading-dots__item"></div>
                        <div class="loading-dots__item"></div>
                        <div class="loading-dots__item"></div>
                        <div class="loading-dots__item"></div>
                        <div class="loading-dots__item"></div>
                    </div>
                </div>
            </div>
        </div>

        <modal-vue title=":("
                   :show="showErrorModal"
                   @close="showErrorModal = false"
                   :buttons='[{text: "Oke", class: "button-brekz button-brekz--rounded button-brekz--yellow button--extra-large", emit_name: "close"}]'>
            <p class="my-3">{{ errorModalContent }}</p>
        </modal-vue>

        <modal-vue title="Bedankt"
                   :show="showPaymentCompletedModal"
                   width="xs">
            <p class="my-3">{{ $t("checkout.paymentSucces") }}</p>
            <p class="mb-2">{{ $t("checkout.backToOrderhistory") }}</p>
            <div class="d-flex justify-content-center"><i class="fal fa-check-circle fa-5x text--green mb-3"></i></div>
        </modal-vue>
    </div>
</template>

<script>
    import 'vue-swipe-actions/dist/vue-swipe-actions.css';
    import { SwipeList, SwipeOut } from 'vue-swipe-actions';
    import CheckoutPaymentCreditCardLogo from './CheckoutPaymentCreditcardLogo';
    import Cleave from 'cleave.js';
    import axios from "axios";
    import ModalVue from "./ModalVue";
    import { handleThreeDsAuthentication } from "../js/docdata";

    export default {
        components: {
            CheckoutPaymentCreditCardLogo,
            SwipeOut,
            SwipeList,
            ModalVue
        },
        props: {
            moduleLink: {
                type: String,
                required: true
            },
            checkoutLink: {
                type: String,
                required: true
            },
            checkoutCancelPaymentLink: {
                type: String,
                required: true
            },
            shopName: {
                type: String,
                default: ''
            }
        },
        data() {
            return {
                windowWidth: '',
                selectedCard: null,
                paymentMethod: "MISTERCASH",
                userCards: [],
                cartArray: [],
                isFetchingCreditCards: false,
                bancontactCode: '',
                cardHolderName: '',
                bancontactExpirationDate: '',
                bancontactCodeError: false,
                cardHolderNameError: false,
                bancontactExpirationDateError: false,
                savePaymentDetails: true,
                creditCardIssuer: 'MISTERCASH',
                useBancontactApp: false,
                paymentStatusTimer: null,
                paymentOrderKey: null,
                OrderId: '',
                hasIFrame: null,
                intentUrl: "",
                qrCode: "",
                qrCodeIsLoaded: false,
                isSubmitting: false,
                useNewCard: false,
                showErrorModal: false,
                reloadPageAfterClosingModal: false,
                errorModalContent: '',
                showPaymentCompletedModal: false,
                inputRefs: [
                    'cardNumber',
                    'cardNameHolder',
                    'cardExpireDate',
                ],
                invalidInputElements: [],
                isValidCard: true,
                isValidCardHolderName: true,
                isValidExpirationDate: true
            };
        },
        methods: {
            isIFrameEmpty() {
                const  iframe =  document.getElementById('Authentication');

                if  (! iframe){
                    this.hasIFrame = false;
                    return;
                }

                this.hasIFrame = true;
            },
            cancelPayment() {
                window.location.href = this.checkoutCancelPaymentLinkWithPaymentKey;
            },
            isInputInvalid(elementReference) {
                const result = this.invalidInputElements.find((item) => {
                    return item === elementReference;
                });

                if (result === undefined) {
                    return false;
                }

                // Can only be invalid once
                this.invalidInputElements.splice(this.invalidInputElements.indexOf(elementReference), 1);
                return true;
            },
            validateBancontactNumber: function ()  {
                if (!this.bancontactCode) {
                    return this.isValidCard = false;
                }
                if (this.bancontactCode.length < 19 || this.bancontactCode.length > 20) {
                    return this.isValidCard = false;
                }
                if (this.isInputInvalid('bancontactCode')) {
                    return this.isValidCard = false;
                }

                this.isValidCard = true;
            },
            validateCardHolderName: function() {
                if (!this.cardHolderName) {
                    return this.isValidCardHolderName = false;
                }
                if (this.cardHolderName.length < 3) {
                    return this.isValidCardHolderName = false;
                }
                if (this.isInputInvalid('cardHolderName')) {
                    return this.isValidCardHolderName = false;
                }

                this.isValidCardHolderName = true;
            },
            validateExpirationDate: function () {
                if (!this.bancontactExpirationDate) {
                    return this.isValidExpirationDate = false;
                }
                if (this.bancontactExpirationDate.length !== 5) {
                    return this.isValidExpirationDate = false;
                }
                if (this.isInputInvalid('bancontactExpirationDate')) {
                    return this.isValidCardHolderName = false;
                }

                const dateNow             = new Date();
                dateNow.setMonth(dateNow.getMonth() - 1); // Allow expiration dates in the current month

                const splitExpirationDate = this.bancontactExpirationDate.split('/');
                const dateCard = new Date(parseInt('20' + splitExpirationDate[1]), parseInt(splitExpirationDate[0]) - 1);

                this.isValidExpirationDate = (dateCard > dateNow);
            },
            cardTypeChanged: function(type) {
                this.creditCardIssuer = type.toUpperCase();
            },
            createNewCard() {
                this.useBancontactApp = false;
                this.useNewCard   = true;
                this.selectedCard = null;
                this.savePaymentDetails = true;
            },
            useBancontactAppClickHandler() {
                this.useBancontactApp = true;
                this.selectedCard     = null;
                this.useNewCard       = false;
            },
            getMobilePaymentData() {

                const formData = new FormData();

                formData.set('card_type', this.creditCardIssuer);
                formData.set('bancontactqr', null);

                axios.post(this.moduleLink, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
                     .then(response => {

                         const data     = response.data

                         if (! data.mobilePayment) {
                             data.redirectUrl ? window.location.href = data.redirectUrl : ""
                             return
                         }
                         this.intentUrl = data.mobilePayment.IntentUrl
                         this.OrderId   = data.order_id
                         this.qrCode    = data.mobilePayment.QRCode
                         this.paymentOrderKey = data.paymentOrderKey

                     }).catch(error => {

                })

            },
            saveCreditCard() {

                if (!this.allInputValid) return;

                const formData   = new FormData();
                const ciphertext = this.getCardCipher();

                formData.set('card_cipher', ciphertext);
                formData.set('card_type', this.creditCardIssuer);
                formData.set('createToken', null);

                this.isSubmitting = true;

                axios.post(this.moduleLink, formData, {
                    headers: { 'Content-Type': 'multipart/form-data' }
                }).then((response) => {
                    if (!response.data.success) {
                        this.isSubmitting      = false;
                        this.errorModalContent = "Sorry!\nEr is iets fout gegaan tijdens de betaling, probeer het later opnieuw.";
                        this.showErrorModal    = true;
                        return;
                    }

                    if (response.data.ddpTokenKey.key) {
                        this.startPayment();
                        this.userCards = response.data.currentTokens ?  response.data.currentTokens : [];
                    }
                }).catch((error) => {
                    let code = "UNKNOWN_ISSUE";
                    console.error("FOUND ERROR in SaveCreditCard: ", error)

                    if (error && error.response) {
                        code = error.response.data.error.code;
                    }

                    if (code.includes('ERROR_INVALID_CARDNUMBER') || code.includes('INVALID_CARDNUMBER')) {
                        this.invalidInputElements.push('bancontactCode');
                    }

                    if (code.includes('INVALID_EXPIRY_DATE') && code.includes('INVALID_EXPIRYDATE')) {
                        this.invalidInputElements.push('bancontactExpirationDate');
                    }
                    if (code.includes('ERROR_CARDHOLDERNAME_MISSING') || code.includes('INVALID_CARDNAME')) {
                        this.invalidInputElements.push('cardHolderName');
                    }

                    this.validateBancontactNumber();
                    this.validateCardHolderName();
                    this.validateExpirationDate();
                    this.isSubmitting = false;
                });
            },
            startPayment() {
                const formData = new FormData();
                formData.set('bankcontactStartPayment', null);

                if (this.useBancontactApp) {
                    if (!this.intentUrl) {
                        this.errorModalContent = this.$t('checkout.errorModalText') + "\n" + this.$t('checkout.errorModalText2');
                        this.showErrorModal    = true;

                        return;
                    }

                    window.location.href = this.intentUrl;
                    return;
                }

                const ciphertext = this.getCardCipher();
                if  (this.selectedCard){
                    formData.set('ddp_token_key', this.selectedCard);
                }
                formData.set('card_cipher', ciphertext);
                formData.set('card_type', this.creditCardIssuer);

                let GAClientId = null;
                let GASessionId = null;
                if (typeof window.getGAClientId === 'function' && typeof window.getGASessionId === 'function') {
                    GAClientId = window.getGAClientId();
                    GASessionId = window.getGASessionId();
                }
                formData.set('ga_client_id', GAClientId);
                formData.set('ga_session_id', GASessionId);

                axios.post(this.moduleLink, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
                     .then(response => {
                         this.isSubmitting = false;

                         if (!response.data.success) {
                             if (response.data.redirectUrl) {
                                 return window.location.href = response.data.redirectUrl;
                             }
                             this.errorModalContent = this.$t('checkout.errorModalText') + "\n" + this.$t('checkout.errorModalText2');
                             this.showErrorModal    = true;
                             return;
                         }

                       if (response.data.redirectUrl) {
                             this.hasIFrame = false;
                             this.OrderId = response.data.order_id;
                             this.paymentOrderKey = response.data.redirectUrl.paymentClusterKey;
                             this.paymentStatusTimer = setInterval(() => {
                                 this.isIFrameEmpty()
                                 this.getOrderStatus()
                             }, 3000);

                             if (Array.isArray(response.data.redirectUrl.redirects)) {
                                 response.data.redirectUrl.redirects.forEach(redirect => {
                                     if  (redirect.purpose === 'HIDDEN_IFRAME') {
                                         this.createHiddenIframeAndSubmitForm(redirect.url, redirect.method, redirect.parameters)
                                     } else {
                                         setTimeout(() => handleThreeDsAuthentication(redirect.url, redirect.parameters, true, response.data.redirectUrl.paymentClusterKey, this), 3000);
                                     }
                                 })
                                 return;
                             }

                             if (response.data.redirectUrl.redirects.purpose === "REDIRECT") {
                                 this.submitForm(response.data.redirectUrl.redirects.url, response.data.redirectUrl.redirects.parameters, response.data.redirectUrl.redirects.method)
                             } else {
                                 handleThreeDsAuthentication(response.data.redirectUrl.redirects.url, response.data.redirectUrl.redirects.parameters, true, response.data.redirectUrl.paymentClusterKey, this);
                             }

                       } else {

                         this.showPaymentCompletedModal = true;

                         setTimeout(() => {

                           response.data.redirectUrl ? window.location.href = response.data.redirectUrl : "";

                         }, 3000);
                       }
                     })
                     .catch((error => {
                         let code = "UNKNOWN_CODE";
                         console.error("FOUND ERROR in StartPayment: ", error)

                         if (error && error.response) {
                             code = error.response.data.error ? error.response.data.error.code : null;
                         }

                         if (code === "UNKNOWN_CODE"){
                             if (error && error.response) {
                                code = error.response.data.code;
                             }
                         }

                         if  (code.includes('UNKNOWN_ERROR')) {
                             this.getCreditCards();
                             return;
                         }

                        if (code.includes('ERROR_INVALID_CARDNUMBER') || code.includes('INVALID_CARDNUMBER') || code.includes('ERROR_START_PAYMENT_INVALID_CARD_NUMBER')) {
                            return this.invalidInputElements.push('bancontactCode');
                        }

                        if (code.includes('INVALID_EXPIRY_DATE') && code.includes('INVALID_EXPIRYDATE')) {
                            return this.invalidInputElements.push('bancontactExpirationDate');
                        }

                        if (code.includes('INVALID_CARD_NAME') || code.includes('INVALID_CARDNAME') || code.includes('MISSING_CARD_HOLDER')) {
                            return this.invalidInputElements.push('cardHolderName');
                        }

                        if (code === "TOKEN_EXPIRED") {
                            this.selectedCard       = 'id';
                            this.useNewCard         = true;
                            this.savePaymentDetails = true;

                            this.getCards();

                            this.showErrorModal    = true;
                            this.errorModalContent = this.$t('checkout.cardExpired');
                        }

                        if (error.response.data.forceReload) {
                            this.reloadPageAfterClosingModal = true;
                        }

                        if (error.response.data.redirectUrl) {
                            return window.location.href = response.data.redirectUrl;
                        }

                        this.validateBancontactNumber();
                        this.validateCardHolderName();
                        this.validateExpirationDate();

                        this.errorModalContent = this.$t('checkout.errorModalText') + "\n" + this.$t('checkout.errorModalText2');
                        this.showErrorModal = true;
                        this.isSubmitting = false;
                }));

            },
            handleSelectedCard(key, paymentMethod) {
                this.selectedCard       = key;
                this.paymentMethod      = paymentMethod;
                this.useBancontactApp   = false;
                this.useNewCard         = false;
                this.savePaymentDetails = false;
            },
            getCardCipher() {
                const cardCode        = this.bancontactCode.replace(/\s+/g, '');
                const splitDates      = this.bancontactExpirationDate.split('/');
                const expirationYear  = splitDates[1];
                const expirationMonth = splitDates[0];

                return window.cseEncrypt(this.cardHolderName, cardCode, expirationMonth, expirationYear);
            },
            getCards() {
                this.isFetchingCreditCards = true;

                axios.get(this.moduleLink, {
                    params: {
                        payment_type: 'MISTERCASH'
                    }
                })
                     .then((response) => {
                         this.userCards             = response.data.currentTokens ? response.data.currentTokens : [];
                         this.isFetchingCreditCards = false;

                         if (this.userCards.length === 0) {
                             this.useNewCard = true;
                         } else if (this.userCards.length === 1) {
                             this.handleSelectedCard(this.userCards[0].key, this.userCards[0].paymentMethod)
                         }
                     })
                     .catch((error) => {
                         this.showErrorModal = true;
                     });
            },
            getCart() {

                axios.get('/module/brekz_my_account_api/cart?action=get')
                     .then((response) => {
                         this.cartArray = response.data;
                     })
                     .catch((error) => {

                     });

            },
            submitForm(path, params, method='post') {

                const form = document.createElement('form');
                form.method = method;
                form.action = path;

                params = params.parameter;

                for(var key in params) {
                    var hiddenField = document.createElement("input")
                    hiddenField.setAttribute('type', "hidden")
                    hiddenField.setAttribute('name', params[key].name)
                    hiddenField.setAttribute('value', params[key]['_'])
                    form.appendChild(hiddenField);
                }

                document.body.appendChild(form);
                form.submit();
            },
            deleteCard(key) {
                const formData = new FormData();
                formData.set('ddp_token_key', key);
                formData.set('deleteToken', null);
                formData.set('payment_type', 'MISTERCASH');

                this.isFetchingCreditCards = true;
                axios.post(this.moduleLink, formData).then(response => {
                    this.userCards             = response.data.currentTokens ? response.data.currentTokens : [];
                    this.selectedCard          = this.userCards.length === 0 ? null : this.handleSelectedCard(this.userCards[0].key, this.userCards[0].paymentMethod);
                    this.isFetchingCreditCards = false;

                    if (this.userCards.length === 0) {
                        this.useNewCard = true;
                    }
                }).catch(error => {
                    console.log(error)
                })
            },
            buttonPressLeft(element) {
                const elementTarget  = element.target;
                const cursorPosition = elementTarget.selectionStart;

                if (cursorPosition === 0) {
                    this.goToPreviousInput(elementTarget.id);
                }
            },
            buttonPressRight(element) {
                const elementTarget  = element.target;
                const cursorPosition = elementTarget.selectionStart;

                if (cursorPosition === elementTarget.maxLength || elementTarget.id === "cardNameHolder") {
                    this.goToNextInput(elementTarget.id);
                }
            },
            goToPreviousInput(currentInputRef) {
                let inputElementIndex = -1;

                this.inputRefs.forEach((value, index) => {
                    if (value === currentInputRef) {
                        inputElementIndex = index;
                    }
                });

                if (inputElementIndex === -1 || inputElementIndex === 0) {
                    return;
                }

                let newSelectedInputElement = this.$refs[this.inputRefs[inputElementIndex - 1]];
                newSelectedInputElement.select();
                newSelectedInputElement.selectionStart = newSelectedInputElement.value.length;
                newSelectedInputElement.selectionEnd   = newSelectedInputElement.value.length;
            },
            goToNextInput(currentInputRef) {
                let inputElementIndex = -1;

                this.inputRefs.forEach((value, index) => {
                    if (value === currentInputRef) {
                        inputElementIndex = index;
                    }
                });

                if (inputElementIndex === -1 || (inputElementIndex === this.inputRefs.length - 1 && currentInputRef !== "cardNameHolder")) {
                    return;
                }

                let newSelectedInputElement = this.$refs[this.inputRefs[inputElementIndex + 1]];
                newSelectedInputElement.select();
                newSelectedInputElement.selectionStart = 0;
                newSelectedInputElement.selectionEnd   = 0;
            },
            createHiddenIframeAndSubmitForm(url, method, parameters) {
                let hiddenIframe = document.createElement('iframe');
                hiddenIframe.src = "about:blank"
                hiddenIframe.style.display = 'none';
                hiddenIframe.id = "hiddenFrame";
                hiddenIframe.name = "hiddenFrame";

                document.body.appendChild(hiddenIframe);

                const idocument = hiddenIframe.contentWindow.document;
                const submitForm = idocument.createElement("form");
                submitForm.setAttribute("target", "hiddenFrame");
                submitForm.setAttribute("method", method);
                submitForm.setAttribute("action", url);

                for(var key in parameters) {
                    var hiddenField = idocument.createElement("input")
                    hiddenField.setAttribute('type', "hidden")
                    hiddenField.setAttribute('name', parameters[key].name)
                    hiddenField.setAttribute('value', JSON.stringify(parameters[key]))
                    submitForm.appendChild(hiddenField);
                }

                const browser_info = {};
                browser_info.java_enabled = navigator.javaEnabled();
                browser_info.java_script_enabled = true;
                browser_info.language = navigator.language;
                browser_info.color_depth = screen.colorDepth;
                browser_info.screen_height = screen.height;
                browser_info.screen_width = screen.width;
                browser_info.time_zone_offset = new Date().getTimezoneOffset();
                browser_info.challenge_window_size = '05';

                hiddenField = idocument.createElement("input")
                hiddenField.setAttribute('type', "hidden")
                hiddenField.setAttribute('name', 'browser_info')
                hiddenField.setAttribute('value', JSON.stringify(browser_info))
                submitForm.appendChild(hiddenField);


                hiddenIframe.appendChild(submitForm);
                submitForm.submit();

            },
            getOrderStatus() {
                if (!this.OrderId || this.showPaymentCompletedModal) {
                    return;
                }
                const formData = new FormData();

                formData.set('order_id', this.OrderId);
                formData.set('key', this.paymentOrderKey);
                formData.set('getPaymentStatusCreditCard', null);

                axios.post(this.moduleLink, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
                     .then(response => {

                         const data = response.data;

                         if (data.paymentStatus.paymentComplete) {
                             clearInterval(this.paymentStatusTimer);

                             this.showPaymentCompletedModal = true;

                             setTimeout(() => {

                                 data.redirectUrl ? window.location.href = data.redirectUrl : "";

                             }, 3000);
                         }  else if (data.paymentStatus.paymentCanceled){
                             clearInterval(this.paymentStatusTimer);

                             data.redirectUrl ? window.location.href = data.redirectUrl : "";
                         }

                     })
                     .catch(error => {
                         console.log(error);
                     })
            },
            updateBanContactCode() {
                this.bancontactCode = this.cleaveBanContactCode.getFormattedValue();
            },
            updateBanContactExpirationDate() {
              this.bancontactExpirationDate = this.cleaveBankContactExpirationDate.getFormattedValue();
            },
            styleDescription(description){
                let clearDescription = description.toString().substring(12);

                return " *** " + clearDescription;
            }
        },
        computed: {
            isMobile() {
                return this.windowWidth <= 768
            },
            allInputValid: function() {

                if (this.useBancontactApp) {
                    return true;
                }

                if (this.selectedCard !== null && !this.useNewCard && !this.useBancontactApp){
                    return true
                }

                if (!this.isEmptyField) {
                    return this.isValidCard &&
                        this.isValidCardHolderName &&
                        this.isValidExpirationDate;
                }
            },
            isCurrentShopAllowed: function() {
                return this.shopName === '' || this.shopName === 'Brekz.be'|| this.shopName === 'Brekz.nl'|| this.shopName === 'Brekz.fr';
            },
            checkoutCancelPaymentLinkWithPaymentKey: function() {
                if (this.paymentOrderKey) {
                    return this.checkoutCancelPaymentLink + '&paymentOrderKey=' + this.paymentOrderKey;
                }
                return this.checkoutCancelPaymentLink;
            },
            isEmptyField() {
                return !this.bancontactCode || !this.bancontactExpirationDate || !this.cardHolderName;

            }
        },
        mounted() {
            this.getCards();
            this.getCart();
            this.windowWidth = window.innerWidth;

            this.getMobilePaymentData();

            window.addEventListener('resize', () => {
                this.windowWidth = window.innerWidth
            });

            this.paymentStatusTimer = setInterval(() => {
                this.getOrderStatus()
            }, 3000);

            this.cleaveBanContactCode = new Cleave(this.$refs.cardNumber, {
                blocks: [4, 4, 4, 5],
                onCreditCardTypeChanged: this.cardTypeChanged
            });

            this.cleaveBankContactExpirationDate = new Cleave(this.$refs.cardExpireDate, {
                date: true,
                datePattern: ['m', 'y'],
            });
        },
        watch: {
            useBancontactApp: function(newValue) {
                if (newValue) {
                    this.savePaymentDetails = false;
                }
            }
        }
    };
</script>
<link href="https://fonts.googleapis.com/css2?family=Share+Tech+Mono&display=swap" rel="stylesheet">
